import { useEffect, useState } from 'react'
import { Outlet, useLocation } from 'react-router-dom'
import MuteluLoading from '../ui/muteluloading'
import ErrorBoundary from '../ui/ErrorBoundary'
import BackButton from '../ui/BackButton'

export default function AppShell() {
  const location = useLocation()
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    const durationFromState =
      typeof location.state?.loadingMs === 'number' ? location.state.loadingMs : 0
    const duration = durationFromState > 0 ? durationFromState : 0

    if (duration <= 0) {
      setLoading(false)
      return undefined
    }

    setLoading(true)
    const timer = window.setTimeout(() => setLoading(false), duration)
    return () => window.clearTimeout(timer)
  }, [location.pathname, location.key, location.state])

  return (
    <div className="mutelu-shell min-h-screen">
      <main className="mx-auto flex min-h-screen w-full max-w-md items-center justify-center px-3 py-4">
        {loading ? (
          <MuteluLoading />
        ) : (
          <div className="relative w-full">
            <BackButton />
            <ErrorBoundary>
              <Outlet />
            </ErrorBoundary>
          </div>
        )}
      </main>
    </div>
  )
}
